(function () {
  'use strict';

  var TOPBAR_KEY = 'topbar_closed';

  function initHeroSlider() {
    document.querySelectorAll('[data-hero-track]').forEach(function (track) {
      var section = track.closest('.hero-slider');
      if (!section || !track.children.length) return;
      var slides = [].slice.call(track.querySelectorAll('[data-hero-slide]'));
      var total = slides.length;
      if (total === 0) return;
      if (total === 1) {
        slides[0].classList.add('is-active');
        slides[0].setAttribute('aria-hidden', 'false');
        var fgOne = slides[0].querySelector('.hero-slide__foreground');
        if (fgOne) {
          fgOne.style.animation = 'none';
          fgOne.offsetHeight;
          fgOne.style.animation = '';
        }
        return;
      }
      var autoplay = section.dataset.autoplay === 'true';
      var interval = parseInt(section.dataset.interval, 10) || 5000;
      var current = 0;
      var timer = null;

      function goTo(index) {
        if (index < 0) index = total - 1;
        if (index >= total) index = 0;
        current = index;
        slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === current);
          s.setAttribute('aria-hidden', i !== current);
        });
        section.querySelectorAll('[data-hero-dot]').forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === current);
          dot.setAttribute('aria-selected', i === current);
        });
        var activeSlide = slides[current];
        var fg = activeSlide ? activeSlide.querySelector('.hero-slide__foreground') : null;
        if (fg) {
          fg.style.animation = 'none';
          fg.offsetHeight;
          fg.style.animation = '';
        }
      }

      function next() {
        goTo(current + 1);
      }

      function prev() {
        goTo(current - 1);
      }

      function startAutoplay() {
        if (!autoplay) return;
        stopAutoplay();
        timer = setInterval(next, interval);
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      section.querySelectorAll('[data-hero-dot]').forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.getAttribute('data-index'), 10);
          if (!isNaN(idx)) {
            goTo(idx);
            startAutoplay();
          }
        });
      });

      var startX = 0;
      var currentX = 0;
      track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        currentX = e.changedTouches[0].clientX;
        var diff = startX - currentX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) next();
          else prev();
          startAutoplay();
        }
      }, { passive: true });

      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);
      section.addEventListener('focusin', stopAutoplay);
      section.addEventListener('focusout', startAutoplay);

      goTo(0);
      startAutoplay();
    });
  }

  function parseCountdownEnd(str) {
    if (!str || typeof str !== 'string') return null;
    var parts = str.trim().split(/\s+/);
    var datePart = parts[0];
    var timePart = parts[1] || '23:59';
    var d = datePart.split('-');
    var t = timePart.split(':');
    if (d.length !== 3) return null;
    var y = parseInt(d[0], 10);
    var m = parseInt(d[1], 10) - 1;
    var day = parseInt(d[2], 10);
    var h = t.length >= 1 ? parseInt(t[0], 10) : 23;
    var min = t.length >= 2 ? parseInt(t[1], 10) : 59;
    var end = new Date(y, m, day, h, min, 0, 0);
    return isNaN(end.getTime()) ? null : end;
  }

  function tickCountdown(bar) {
    var endStr = bar.getAttribute('data-countdown-end');
    if (!endStr) return;
    var end = parseCountdownEnd(endStr);
    if (!end) return;
    var now = new Date();
    var display = bar.querySelector('[data-countdown-display]');
    if (!display) return;
    if (now >= end) {
      display.setAttribute('data-countdown-finished', '');
      var daysEl = bar.querySelector('[data-countdown-days]');
      var hoursEl = bar.querySelector('[data-countdown-hours]');
      var minsEl = bar.querySelector('[data-countdown-mins]');
      var secsEl = bar.querySelector('[data-countdown-secs]');
      if (daysEl) daysEl.textContent = '0';
      if (hoursEl) hoursEl.textContent = '00';
      if (minsEl) minsEl.textContent = '00';
      if (secsEl) secsEl.textContent = '00';
      return;
    }
    var diff = end - now;
    var days = Math.floor(diff / (24 * 60 * 60 * 1000));
    var rest = diff % (24 * 60 * 60 * 1000);
    var hours = Math.floor(rest / (60 * 60 * 1000));
    rest = rest % (60 * 60 * 1000);
    var mins = Math.floor(rest / (60 * 1000));
    rest = rest % (60 * 1000);
    var secs = Math.floor(rest / 1000);
    var daysEl = bar.querySelector('[data-countdown-days]');
    var hoursEl = bar.querySelector('[data-countdown-hours]');
    var minsEl = bar.querySelector('[data-countdown-mins]');
    var secsEl = bar.querySelector('[data-countdown-secs]');
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    if (daysEl) daysEl.textContent = days;
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minsEl) minsEl.textContent = pad(mins);
    if (secsEl) secsEl.textContent = pad(secs);
  }

  function tickAllCountdowns() {
    document.querySelectorAll('[data-countdown-display]').forEach(function (display) {
      var bar = display.closest('.top-bar');
      if (!bar) return;
      var endStr = display.getAttribute('data-countdown-end') || bar.getAttribute('data-countdown-end');
      if (!endStr) {
        var badge = display.querySelector('.top-bar__countdown-badge');
        if (badge) endStr = badge.getAttribute('data-countdown-end');
      }
      if (endStr) {
        bar.setAttribute('data-countdown-end', endStr);
        tickCountdown(bar);
      }
    });
  }

  function initTopBarCountdown() {
    tickAllCountdowns();
    if (window._topBarCountdownInterval) clearInterval(window._topBarCountdownInterval);
    window._topBarCountdownInterval = setInterval(tickAllCountdowns, 1000);
    document.addEventListener('shopify:section:load', function () {
      tickAllCountdowns();
      if (typeof initMegamenu === 'function') initMegamenu();
    });
  }

  var searchDebounceTimer = null;

  function openSearchDrawer(query) {
    query = query || '';
    // Cerrar el cart drawer si está abierto
    if (typeof Cart !== 'undefined' && typeof Cart.closeDrawer === 'function') {
      Cart.closeDrawer();
    }
    var drawer = document.querySelector('[data-search-drawer]');
    var overlay = document.querySelector('[data-search-overlay]');
    var trigger = document.querySelector('[data-search-open]');
    if (drawer) {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    }
    if (overlay) {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
    }
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    setTimeout(function () {
      var input = document.querySelector('[data-search-input]');
      if (input) {
        if (query) {
          input.value = query;
          // Disparar evento input para activar la búsqueda automática
          var inputEvent = new Event('input', { bubbles: true });
          input.dispatchEvent(inputEvent);
        }
        input.focus();
      }
    }, 100);
  }
  
  function openSearchDrawerWithQuery(query) {
    openSearchDrawer(query);
  }

  function closeSearchDrawer() {
    var drawer = document.querySelector('[data-search-drawer]');
    var overlay = document.querySelector('[data-search-overlay]');
    var trigger = document.querySelector('[data-search-open]');
    var input = document.querySelector('[data-search-input]');
    var results = document.querySelector('[data-search-results]');
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
    if (overlay) {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
    }
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (input) { input.value = ''; }
    if (results) { results.innerHTML = ''; }
  }
  
  // Exportar al scope global para que pueda ser llamada desde otros scripts
  window.closeSearchDrawer = closeSearchDrawer;

  function formatSearchPrice(value) {
    if (value == null || (typeof value !== 'number' && typeof value !== 'string')) return '';
    var n = Number(String(value).replace(/,/g, ''));
    if (isNaN(n)) return '';
    var fixed = n % 1 === 0 ? n.toFixed(2) : n.toFixed(2);
    return '$ ' + fixed.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function renderSearchResults(container, products, query) {
    if (!container) return;
    container.classList.remove('is-loading');
    if (!products || products.length === 0) {
      container.innerHTML = '<p class="header-search-drawer__empty">No hay resultados para &quot;' + (query || '') + '&quot;</p>';
      return;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    var html = '<div class="header-search-drawer__grid">';
    products.forEach(function (p) {
      var img = (p.image || (p.featured_image && p.featured_image.url)) ? (p.image || p.featured_image.url) : '';
      var v0 = p.variants && p.variants[0];
      var priceVal = p.price != null ? Number(p.price) : (v0 && v0.price != null ? Number(v0.price) : null);
      var compareVal = (p.compare_at_price_max != null && Number(p.compare_at_price_max) > 0 ? Number(p.compare_at_price_max) : null) ||
        (p.compare_at_price_min != null && Number(p.compare_at_price_min) > 0 ? Number(p.compare_at_price_min) : null) ||
        (p.compare_at_price != null && Number(p.compare_at_price) > 0 ? Number(p.compare_at_price) : null) ||
        (v0 && v0.compare_at_price != null && Number(v0.compare_at_price) > 0 ? Number(v0.compare_at_price) : null);
      var onSale = compareVal != null && priceVal != null && compareVal > priceVal;
      var discountPercent = onSale ? Math.round((compareVal - priceVal) / compareVal * 100) : 0;
      var priceStr = priceVal != null ? formatSearchPrice(priceVal) : '';
      var compareStr = onSale ? formatSearchPrice(compareVal) : '';
      html += '<a href="' + (root.replace(/\/$/, '') + p.url) + '" class="header-search-drawer__item">';
      if (img) html += '<img src="' + img + '" alt="" class="header-search-drawer__item-img" width="160" height="160" loading="lazy">';
      else html += '<div class="header-search-drawer__item-img" style="background:#f0f0f0;aspect-ratio:1;border-radius:8px;"></div>';
      html += '<div class="header-search-drawer__item-content">';
      html += '<p class="header-search-drawer__item-title">' + (p.title || '').replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</p>';
      html += '<div class="header-search-drawer__item-price-row">';
      if (onSale && discountPercent > 0) html += '<span class="header-search-drawer__item-badge">-' + discountPercent + '%</span>';
      if (compareStr) html += '<span class="header-search-drawer__item-price header-search-drawer__item-price--compare">' + compareStr + '</span>';
      if (priceStr) html += '<span class="header-search-drawer__item-price">' + priceStr + '</span>';
      html += '</div></div></a>';
    });
    html += '</div>';
    container.innerHTML = html;
  }

  function fetchSearchSuggestions(query, callback) {
    if (!query || query.trim().length < 2) {
      if (callback) callback([]);
      return;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(query.trim()) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) ? data.resources.results.products : [];
        if (callback) callback(products);
      })
      .catch(function () { if (callback) callback([]); });
  }

  function initHeaderSearch() {
    // Remover listeners anteriores para evitar duplicados
    document.querySelectorAll('[data-header-search-trigger]').forEach(function (element) {
      // Clonar el elemento para remover todos los listeners
      var newElement = element.cloneNode(true);
      element.parentNode.replaceChild(newElement, element);
    });
    
    // Manejar el campo de búsqueda en el header - solo como trigger para abrir el modal
    document.querySelectorAll('[data-header-search-trigger]').forEach(function (element) {
      element.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // Asegurarse de que el overlay del cart drawer no esté bloqueando
        var cartOverlay = document.querySelector('[data-cart-drawer-overlay]');
        if (cartOverlay) {
          cartOverlay.style.pointerEvents = 'none';
          cartOverlay.style.opacity = '0';
          cartOverlay.setAttribute('aria-hidden', 'true');
          cartOverlay.classList.remove('is-open');
        }
        
        // Cerrar el cart drawer si está abierto
        var drawer = document.querySelector('[data-cart-drawer]');
        
        if (drawer && drawer.classList.contains('is-open')) {
          if (typeof Cart !== 'undefined' && typeof Cart.closeDrawer === 'function') {
            Cart.closeDrawer();
          }
          setTimeout(function() {
            openSearchDrawer();
          }, 200);
        } else {
          // Pequeño delay para asegurar que cualquier overlay se haya limpiado
          setTimeout(function() {
            openSearchDrawer();
          }, 50);
        }
      }, true); // Usar capture phase
    });
    
    // Mantener funcionalidad del drawer si existe el botón de abrir
    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        
        // Asegurarse de que el cart drawer esté cerrado
        var drawer = document.querySelector('[data-cart-drawer]');
        var overlay = document.querySelector('[data-cart-drawer-overlay]');
        
        if (drawer && drawer.classList.contains('is-open')) {
          if (typeof Cart !== 'undefined' && typeof Cart.closeDrawer === 'function') {
            Cart.closeDrawer();
          }
          // Limpiar el overlay manualmente
          if (overlay) {
            overlay.style.pointerEvents = 'none';
            overlay.style.opacity = '0';
            overlay.setAttribute('aria-hidden', 'true');
          }
          // Delay más largo para asegurar que el overlay se haya cerrado completamente
          setTimeout(function() {
            openSearchDrawer();
          }, 150);
        } else {
          // Si el drawer ya está cerrado, abrir el buscador inmediatamente
          openSearchDrawer();
        }
      }, true); // Usar capture phase para capturar el evento antes que otros listeners
    });
    document.querySelectorAll('[data-search-overlay]').forEach(function (el) {
      el.addEventListener('click', closeSearchDrawer);
    });
    document.querySelectorAll('[data-search-close]').forEach(function (el) {
      el.addEventListener('click', closeSearchDrawer);
    });
    document.querySelectorAll('[data-search-input]').forEach(function (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim();
        var resultsEl = document.querySelector('[data-search-results]');
        if (!resultsEl) return;
        if (searchDebounceTimer) clearTimeout(searchDebounceTimer);
        if (q.length < 2) {
          resultsEl.innerHTML = '';
          return;
        }
        resultsEl.classList.add('is-loading');
        resultsEl.innerHTML = '<p class="header-search-drawer__empty">Buscando...</p>';
        searchDebounceTimer = setTimeout(function () {
          searchDebounceTimer = null;
          fetchSearchSuggestions(q, function (products) {
            renderSearchResults(resultsEl, products, q);
          });
        }, 280);
      });
    });
  }
  
  // Exportar al scope global para que pueda ser llamada después de renderizar secciones
  window.initHeaderSearch = initHeaderSearch;

  function initMobileMenu() {
    var openBtn = document.querySelector('[data-mobile-menu-open]');
    var closeBtn = document.querySelector('[data-mobile-menu-close]');
    var overlay = document.querySelector('[data-mobile-menu-overlay]');
    var panel = document.querySelector('[data-mobile-menu-panel]');
    if (!panel || !overlay) return;

    function openPanel() {
      panel.classList.add('is-open');
      overlay.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('mobile-menu-open');
    }

    function closePanel() {
      panel.classList.remove('is-open');
      overlay.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('mobile-menu-open');
    }

    if (openBtn) openBtn.addEventListener('click', openPanel);
    if (closeBtn) closeBtn.addEventListener('click', closePanel);
    overlay.addEventListener('click', closePanel);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) closePanel();
    });
  }

  function initTopBar() {
    document.querySelectorAll('[data-topbar-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var topbar = btn.closest('.top-bar');
        if (!topbar) return;
        if (topbar.dataset.dismissible === 'true') {
          try {
            localStorage.setItem(TOPBAR_KEY, '1');
          } catch (e) {}
          topbar.classList.add('is-closed');
          topbar.setAttribute('aria-hidden', 'true');
        }
      });
    });
    if (typeof localStorage !== 'undefined') {
      try {
        var closed = localStorage.getItem(TOPBAR_KEY);
        if (closed === '1') {
          document.querySelectorAll('.top-bar[data-dismissible="true"]').forEach(function (el) {
            el.classList.add('is-closed');
            el.setAttribute('aria-hidden', 'true');
          });
        }
      } catch (e) {}
    }
  }

  function initCategoryCards() {
    document.querySelectorAll('[data-category-cards]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-category-track]');
      var prevBtn = wrap.querySelector('[data-category-prev]');
      var nextBtn = wrap.querySelector('[data-category-next]');
      if (!track || (!prevBtn && !nextBtn)) return;
      var cards = track.querySelectorAll('.category-card');
      var gap = 16;
      function scrollByCard(direction) {
        var cardWidth = cards.length ? cards[0].offsetWidth + gap : track.clientWidth;
        track.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
    });
  }

  function initProductGallery() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var track = gallery.querySelector('[data-product-gallery-track]');
      var thumbs = gallery.querySelectorAll('[data-product-gallery-thumb]');
      var slides = track ? [].slice.call(track.querySelectorAll('[data-product-gallery-slide]')) : [];
      var total = slides.length;
      if (total <= 1) return;
      var current = 0;
      var timer = null;
      var autoplayInterval = 5000;

      function goTo(index) {
        if (index < 0) index = total - 1;
        if (index >= total) index = 0;
        current = index;
        slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === current);
          s.setAttribute('aria-hidden', i !== current);
        });
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === current);
          thumb.setAttribute('aria-selected', i === current);
        });
      }

      function startAutoplay() {
        stopAutoplay();
        timer = setInterval(function () {
          goTo(current + 1);
        }, autoplayInterval);
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = parseInt(thumb.getAttribute('data-index'), 10);
          if (!isNaN(idx)) {
            goTo(idx);
            startAutoplay(); // reinicia el contador para no cambiar la foto recién elegida
          }
        });
      });

      // Flechas (escritorio: no hay swipe con ratón)
      var prevBtn = gallery.querySelector('[data-product-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-product-gallery-next]');
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(current - 1);
          startAutoplay();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(current + 1);
          startAutoplay();
        });
      }

      // Zoom con el ratón sobre la imagen activa (solo punteros de precisión)
      if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        track.addEventListener('mousemove', function (e) {
          var img = track.querySelector('.product-gallery__slide.is-active img');
          if (!img) return;
          var rect = track.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width) * 100;
          var y = ((e.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = x + '% ' + y + '%';
        });
        track.addEventListener('mouseenter', function () {
          track.classList.add('is-zoomed');
        });
        track.addEventListener('mouseleave', function () {
          track.classList.remove('is-zoomed');
          var img = track.querySelector('.product-gallery__slide.is-active img');
          if (img) img.style.transformOrigin = '';
        });
      }

      var startX = 0;
      track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        var endX = e.changedTouches[0].clientX;
        var diff = startX - endX;
        if (Math.abs(diff) > 50) {
          goTo(current + (diff > 0 ? 1 : -1));
          startAutoplay();
        }
      }, { passive: true });

      goTo(0);
      startAutoplay();
    });
  }

  function initVariantPicker() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var form = picker.closest('form');
      if (!form) return;
      var variantIdInput = form.querySelector('input[name="id"]') || form.querySelector('[data-variant-id-input]');
      var scriptEl = picker.querySelector('[data-variant-picker-json]');
      if (!variantIdInput || !scriptEl) return;
      var variants = [];
      try {
        variants = JSON.parse(scriptEl.textContent || '[]');
      } catch (e) {
        return;
      }
      if (variants.length === 0) return;

      function getSelectedValues() {
        var inputs = picker.querySelectorAll('.variant-picker__input:checked');
        var byIndex = {};
        inputs.forEach(function (input) {
          var idx = parseInt(input.getAttribute('data-option-index'), 10);
          if (!isNaN(idx)) byIndex[idx] = input.getAttribute('data-option-value') || '';
        });
        var maxIdx = -1;
        Object.keys(byIndex).forEach(function (k) {
          var n = parseInt(k, 10);
          if (n > maxIdx) maxIdx = n;
        });
        var arr = [];
        for (var i = 0; i <= maxIdx; i++) arr.push(byIndex[i] || '');
        return arr;
      }

      function findVariant(selectedValues) {
        for (var v = 0; v < variants.length; v++) {
          var variant = variants[v];
          var match = true;
          for (var i = 0; i < 3; i++) {
            var opt = (variant['option' + (i + 1)] || '').toString();
            var sel = (selectedValues[i] || '').toString();
            if (opt !== sel) {
              match = false;
              break;
            }
          }
          if (match) return variant;
        }
        return null;
      }

      function updateVariantId() {
        var selectedValues = getSelectedValues();
        var variant = findVariant(selectedValues);
        if (variant && variantIdInput) {
          variantIdInput.value = variant.id;
          variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          variantIdInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }

      picker.querySelectorAll('.variant-picker__input').forEach(function (input) {
        input.addEventListener('change', updateVariantId);
      });
    });
  }

  function initSellingPlanWidget() {
    var HIDDEN_CLASS = 'selling-plan-widget__variant--hidden';
    document.querySelectorAll('[data-selling-plan-widget]').forEach(function (widget) {
      var form = widget.closest('form');
      if (!form) return;
      var variantIdInput = form.querySelector('input[name="id"]') || form.querySelector('[data-variant-id-input]');
      var sellingPlanInput = form.querySelector('input[name="selling_plan"]') || form.querySelector('[data-selling-plan-input]');
      var sections = widget.querySelectorAll('[data-variant-id]');

      function getCurrentVariantId() {
        if (!variantIdInput) return null;
        return (variantIdInput.value || '').trim();
      }

      function syncLastConfirmedSubscriptionRadio() {
        var visibleSection = widget.querySelector('.selling-plan-widget__variant:not(.' + HIDDEN_CLASS + ')');
        if (!visibleSection) {
          widget._lastConfirmedSubscriptionRadio = null;
          return;
        }
        var oneTimeChecked = visibleSection.querySelector('[data-radio-type="one_time_purchase"]:checked');
        if (oneTimeChecked) {
          widget._lastConfirmedSubscriptionRadio = null;
          return;
        }
        var sub = visibleSection.querySelector('[data-radio-type="selling_plan"]:checked:not([disabled])');
        widget._lastConfirmedSubscriptionRadio = sub || null;
      }

      function updateVisibility() {
        var currentId = getCurrentVariantId();
        sections.forEach(function (section) {
          var variantId = section.getAttribute('data-variant-id');
          var match = variantId === currentId;
          section.classList.toggle(HIDDEN_CLASS, !match);
        });
        syncLastConfirmedSubscriptionRadio();
      }

      function updateSellingPlanInput() {
        if (!sellingPlanInput) return;
        var visibleSection = widget.querySelector('.selling-plan-widget__variant:not(.' + HIDDEN_CLASS + ')');
        if (!visibleSection) {
          sellingPlanInput.value = '';
          updateSubscriptionDisclaimer();
          updateSubscriptionBlockedButton();
          return;
        }
        var checked = visibleSection.querySelector('.selling-plan-widget__input:checked:not([disabled])');
        if (!checked) {
          sellingPlanInput.value = '';
          updateSubscriptionDisclaimer();
          updateSubscriptionBlockedButton();
          return;
        }
        var radioType = checked.getAttribute('data-radio-type');
        if (radioType === 'one_time_purchase') {
          sellingPlanInput.value = '';
        } else {
          var planId = checked.getAttribute('data-selling-plan-id');
          sellingPlanInput.value = planId || '';
        }
        updateSubscriptionDisclaimer();
        updateSubscriptionBlockedButton();
      }

      function updateSubscriptionDisclaimer() {
        var disclaimer = widget.querySelector('[data-subscription-disclaimer]');
        if (!disclaimer) return;
        var visibleSection = widget.querySelector('.selling-plan-widget__variant:not(.' + HIDDEN_CLASS + ')');
        var isSubscription = false;
        if (visibleSection) {
          var chk = visibleSection.querySelector('.selling-plan-widget__input:checked:not([disabled])');
          isSubscription = chk && chk.getAttribute('data-radio-type') === 'selling_plan';
        }
        disclaimer.classList.toggle('selling-plan-widget__disclaimer--visible', isSubscription);
        disclaimer.setAttribute('aria-hidden', isSubscription ? 'false' : 'true');
      }

      function updateSubscriptionBlockedButton() {
        var addBtns = form.querySelectorAll('.main-product__buttons button[name="add"]');
        if (!addBtns.length) return;
        var visibleSection = widget.querySelector('.selling-plan-widget__variant:not(.' + HIDDEN_CLASS + ')');
        var blockAdd = false;
        if (visibleSection) {
          var hasValid = visibleSection.querySelector('.selling-plan-widget__input:checked:not([disabled])');
          if (!hasValid && visibleSection.classList.contains('selling-plan-widget__variant--high-discount')) {
            blockAdd = true;
          }
        }
        addBtns.forEach(function (addBtn) {
          if (blockAdd) {
            addBtn.disabled = true;
            addBtn.setAttribute('aria-disabled', 'true');
          } else {
            addBtn.disabled = false;
            addBtn.removeAttribute('aria-disabled');
          }
        });
      }

      function closeSubscriptionModal() {
        var modal = widget.querySelector('[data-subscription-confirm-modal]');
        if (!modal) return;
        modal.hidden = true;
        modal.classList.remove('subscription-confirm-modal--open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('subscription-confirm-modal-active');
        widget._pendingSubscriptionRadio = null;
        if (widget._subscriptionModalEscHandler) {
          document.removeEventListener('keydown', widget._subscriptionModalEscHandler);
          widget._subscriptionModalEscHandler = null;
        }
      }

      function updateSubscriptionAcceptButtonState(modal) {
        if (!modal) return;
        var cb = modal.querySelector('[data-subscription-terms-checkbox]');
        var acc = modal.querySelector('[data-subscription-confirm-accept]');
        if (!acc) return;
        var ok = !cb || cb.checked;
        acc.disabled = !ok;
        if (!ok) acc.setAttribute('aria-disabled', 'true');
        else acc.removeAttribute('aria-disabled');
      }

      function openSubscriptionModal(pendingRadio) {
        var modal = widget.querySelector('[data-subscription-confirm-modal]');
        if (!modal || !pendingRadio) return;
        widget._pendingSubscriptionRadio = pendingRadio;
        var intervalEl = modal.querySelector('[data-subscription-confirm-interval]');
        if (intervalEl) {
          var label = pendingRadio.getAttribute('data-selling-plan-interval-label') || '';
          intervalEl.textContent = label || '—';
        }
        var termsCb = modal.querySelector('[data-subscription-terms-checkbox]');
        if (termsCb) termsCb.checked = true;
        var termsPanel = modal.querySelector('[data-subscription-terms-panel]');
        var termsToggle = modal.querySelector('[data-subscription-terms-toggle]');
        if (termsPanel) termsPanel.setAttribute('hidden', '');
        if (termsToggle) termsToggle.setAttribute('aria-expanded', 'false');
        updateSubscriptionAcceptButtonState(modal);
        modal.hidden = false;
        modal.classList.add('subscription-confirm-modal--open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('subscription-confirm-modal-active');
        var acceptBtn = modal.querySelector('[data-subscription-confirm-accept]');
        if (acceptBtn) {
          setTimeout(function () {
            acceptBtn.focus();
          }, 10);
        }
        widget._subscriptionModalEscHandler = function (e) {
          if (e.key === 'Escape') {
            e.preventDefault();
            closeSubscriptionModal();
          }
        };
        document.addEventListener('keydown', widget._subscriptionModalEscHandler);
      }

      function onPurchaseOptionChange(radio) {
        if (!radio.checked) return;
        if (widget.__subscriptionModalApplying) {
          updateSellingPlanInput();
          if (typeof updateProductPriceDisplay === 'function') updateProductPriceDisplay(form);
          return;
        }
        var type = radio.getAttribute('data-radio-type');
        if (type !== 'selling_plan') {
          syncLastConfirmedSubscriptionRadio();
          updateSellingPlanInput();
          if (typeof updateProductPriceDisplay === 'function') updateProductPriceDisplay(form);
          return;
        }
        if (radio.disabled) return;
        var visibleSection = widget.querySelector('.selling-plan-widget__variant:not(.' + HIDDEN_CLASS + ')');
        if (!visibleSection) return;
        var oneTime = visibleSection.querySelector('[data-radio-type="one_time_purchase"]');
        if (oneTime) {
          widget.__subscriptionModalApplying = true;
          radio.checked = false;
          oneTime.checked = true;
          widget.__subscriptionModalApplying = false;
          syncLastConfirmedSubscriptionRadio();
          updateSellingPlanInput();
          if (typeof updateProductPriceDisplay === 'function') updateProductPriceDisplay(form);
          openSubscriptionModal(radio);
          return;
        }
        var prevConfirmed = widget._lastConfirmedSubscriptionRadio;
        if (prevConfirmed && prevConfirmed !== radio) {
          widget.__subscriptionModalApplying = true;
          radio.checked = false;
          prevConfirmed.checked = true;
          widget.__subscriptionModalApplying = false;
          syncLastConfirmedSubscriptionRadio();
          updateSellingPlanInput();
          if (typeof updateProductPriceDisplay === 'function') updateProductPriceDisplay(form);
          openSubscriptionModal(radio);
          return;
        }
        widget._lastConfirmedSubscriptionRadio = radio;
        updateSellingPlanInput();
        if (typeof updateProductPriceDisplay === 'function') updateProductPriceDisplay(form);
      }

      function acceptSubscriptionModal() {
        var modalEl = widget.querySelector('[data-subscription-confirm-modal]');
        var termsCb = modalEl && modalEl.querySelector('[data-subscription-terms-checkbox]');
        if (termsCb && !termsCb.checked) {
          return;
        }
        var pending = widget._pendingSubscriptionRadio;
        if (!pending || !pending.getAttribute || pending.disabled) {
          closeSubscriptionModal();
          return;
        }
        var visibleSection = widget.querySelector('.selling-plan-widget__variant:not(.' + HIDDEN_CLASS + ')');
        if (!visibleSection || !visibleSection.contains(pending)) {
          closeSubscriptionModal();
          return;
        }
        widget.__subscriptionModalApplying = true;
        var oneTime = visibleSection.querySelector('[data-radio-type="one_time_purchase"]');
        if (oneTime) oneTime.checked = false;
        pending.checked = true;
        widget._lastConfirmedSubscriptionRadio = pending;
        widget.__subscriptionModalApplying = false;
        updateSellingPlanInput();
        if (typeof updateProductPriceDisplay === 'function') updateProductPriceDisplay(form);
        closeSubscriptionModal();
      }

      var confirmModal = widget.querySelector('[data-subscription-confirm-modal]');
      if (confirmModal) {
        var acc = confirmModal.querySelector('[data-subscription-confirm-accept]');
        var can = confirmModal.querySelector('[data-subscription-confirm-cancel]');
        var back = confirmModal.querySelector('[data-subscription-confirm-backdrop]');
        var termsToggle = confirmModal.querySelector('[data-subscription-terms-toggle]');
        var termsPanel = confirmModal.querySelector('[data-subscription-terms-panel]');
        var termsCheckbox = confirmModal.querySelector('[data-subscription-terms-checkbox]');
        if (acc) acc.addEventListener('click', acceptSubscriptionModal);
        if (can) can.addEventListener('click', closeSubscriptionModal);
        if (back) back.addEventListener('click', closeSubscriptionModal);
        if (termsToggle && termsPanel) {
          termsToggle.addEventListener('click', function (e) {
            e.preventDefault();
            var hidden = termsPanel.hasAttribute('hidden');
            if (hidden) {
              termsPanel.removeAttribute('hidden');
              termsToggle.setAttribute('aria-expanded', 'true');
            } else {
              termsPanel.setAttribute('hidden', '');
              termsToggle.setAttribute('aria-expanded', 'false');
            }
          });
        }
        if (termsCheckbox) {
          termsCheckbox.addEventListener('change', function () {
            updateSubscriptionAcceptButtonState(confirmModal);
          });
        }
        updateSubscriptionAcceptButtonState(confirmModal);
      }

      updateVisibility();
      updateSellingPlanInput();
      updateSubscriptionDisclaimer();
      syncLastConfirmedSubscriptionRadio();

      if (variantIdInput) {
        variantIdInput.addEventListener('change', function () {
          closeSubscriptionModal();
          updateVisibility();
          updateSellingPlanInput();
          if (typeof updateProductPriceDisplay === 'function') updateProductPriceDisplay(form);
        });
        variantIdInput.addEventListener('input', function () {
          closeSubscriptionModal();
          updateVisibility();
          updateSellingPlanInput();
          if (typeof updateProductPriceDisplay === 'function') updateProductPriceDisplay(form);
        });
      }

      widget.querySelectorAll('.selling-plan-widget__input').forEach(function (radio) {
        radio.addEventListener('change', function () {
          onPurchaseOptionChange(radio);
        });
      });
    });
  }

  function formatPriceWithSup(str) {
    if (!str || typeof str !== 'string') return '';
    var text = str.trim();
    if (!text) return '';
    var withSpace = text.replace(/^\$(\d)/, '$ $1');
    var parts = withSpace.match(/^(.*)([.,]\d{2})(\s*.*)?$/);
    if (parts) {
      return parts[1] + '<sup class="main-product__price-dec">' + parts[2] + '</sup>' + (parts[3] || '');
    }
    return text;
  }

  function formatCentsAsMoney(cents, currency) {
    if (cents == null || isNaN(cents)) return '';
    try {
      var amount = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return '$ ' + amount;
    } catch (e) {
      return '$ ' + (cents / 100).toFixed(2);
    }
  }

  function updateProductPriceDisplay(form) {
    var priceDisplay = form.querySelector('[data-product-price-display]');
    if (!priceDisplay) return;
    var priceCurrent = priceDisplay.querySelector('[data-price-current]');
    var priceCompare = priceDisplay.querySelector('[data-price-compare]');
    var priceCompareWrap = priceDisplay.querySelector('[data-price-compare-wrap]');
    var priceBadge = priceDisplay.querySelector('[data-price-badge]');
    var variantIdInput = form.querySelector('input[name="id"]') || form.querySelector('[data-variant-id-input]');
    var variantId = variantIdInput ? (variantIdInput.value || '').trim() : '';
    var qtyInput = form.querySelector('[data-quantity-input]');
    var quantity = parseInt(qtyInput && qtyInput.value, 10) || 1;
    quantity = Math.max(1, Math.min(99, quantity));
    var widget = form.querySelector('[data-selling-plan-widget]');
    var priceStr = '';
    var compareStr = '';
    var priceCents = 0;
    var compareAtCents = 0;
    var currency = form.dataset && form.dataset.currency ? form.dataset.currency : 'USD';

    if (widget) {
      var visible = widget.querySelector('.selling-plan-widget__variant:not(.selling-plan-widget__variant--hidden)');
      if (visible) {
        var checked = visible.querySelector('.selling-plan-widget__input:checked');
        if (checked) {
          priceStr = checked.getAttribute('data-variant-price') || '';
          compareStr = checked.getAttribute('data-variant-compare-at-price') || '';
          priceCents = parseInt(checked.getAttribute('data-variant-price-cents'), 10) || 0;
          compareAtCents = parseInt(checked.getAttribute('data-variant-compare-at-cents'), 10) || 0;
        }
      }
    }
    if (!priceStr && variantId) {
      var script = form.querySelector('[data-product-prices]');
      if (script) {
        try {
          var data = JSON.parse(script.textContent);
          var v = data.variants && data.variants[variantId];
          if (v) {
            priceStr = v.price || '';
            compareStr = v.compare_at || '';
            priceCents = parseInt(v.price_cents, 10) || 0;
            compareAtCents = parseInt(v.compare_at_cents, 10) || 0;
          }
        } catch (e) {}
      }
    }

    var totalCents = priceCents * quantity;
    var compareAtTotalCents = compareAtCents * quantity;
    var displayPriceStr = totalCents > 0 ? formatCentsAsMoney(totalCents, currency) : priceStr;
    var displayCompareStr = compareAtTotalCents > 0 ? formatCentsAsMoney(compareAtTotalCents, currency) : compareStr;

    if (priceCurrent) priceCurrent.innerHTML = formatPriceWithSup(displayPriceStr);

    var isSubscription = false;
    if (widget && visible) {
      var checkedRadio = visible.querySelector('.selling-plan-widget__input:checked');
      isSubscription = checkedRadio && checkedRadio.getAttribute('data-radio-type') === 'selling_plan';
    }
    if (priceDisplay) {
      priceDisplay.classList.toggle('main-product__price-wrap--subscription', !!isSubscription);
    }

    var showCompare = displayCompareStr && displayCompareStr !== displayPriceStr && compareAtCents > priceCents;
    if (priceCompareWrap) {
      priceCompareWrap.style.display = showCompare ? '' : 'none';
      if (priceCompare) priceCompare.innerHTML = formatPriceWithSup(displayCompareStr);
    } else if (priceCompare) {
      priceCompare.innerHTML = formatPriceWithSup(displayCompareStr);
      priceCompare.style.display = showCompare ? '' : 'none';
      priceCompare.setAttribute('aria-hidden', !showCompare);
    }

    if (priceBadge) {
      var discountPercent = 0;
      var compareAtForBadge = compareAtCents;
      var regularPriceCents = 0;
      if (widget && visible) {
        var checkedRadio = visible.querySelector('.selling-plan-widget__input:checked');
        var isSub = checkedRadio && checkedRadio.getAttribute('data-radio-type') === 'selling_plan';
        if (isSub && checkedRadio) {
          var originalCompare = parseInt(checkedRadio.getAttribute('data-variant-compare-at-original-cents'), 10) || 0;
          var oneTimeRadio = visible.querySelector('input[data-radio-type="one_time_purchase"]');
          if (oneTimeRadio) {
            regularPriceCents = parseInt(oneTimeRadio.getAttribute('data-variant-price-cents'), 10) || 0;
          } else if (variantId) {
            var scriptP = form.querySelector('[data-product-prices]');
            if (scriptP) {
              try {
                var dataP = JSON.parse(scriptP.textContent);
                var vP = dataP.variants && dataP.variants[variantId];
                if (vP) regularPriceCents = parseInt(vP.price_cents, 10) || 0;
              } catch (e) {}
            }
          }
          if (originalCompare > 0 && regularPriceCents > 0 && priceCents < regularPriceCents) {
            var discountFromCompare = (originalCompare - regularPriceCents) / originalCompare * 100;
            var subscriptionDiscount = (regularPriceCents - priceCents) / regularPriceCents * 100;
            discountPercent = Math.round(discountFromCompare + subscriptionDiscount);
            discountPercent = Math.min(99, Math.max(0, discountPercent));
          } else if (originalCompare > 0 && priceCents < originalCompare) {
            discountPercent = Math.round((originalCompare - priceCents) / originalCompare * 100);
          } else if (regularPriceCents > 0 && priceCents < regularPriceCents) {
            discountPercent = Math.round((regularPriceCents - priceCents) / regularPriceCents * 100);
            discountPercent = Math.max(15, Math.min(99, discountPercent));
          }
        } else {
          if (compareAtForBadge > 0 && priceCents < compareAtForBadge) {
            discountPercent = Math.round((compareAtForBadge - priceCents) / compareAtForBadge * 100);
          }
        }
      } else {
        if (compareAtForBadge > 0 && priceCents < compareAtForBadge) {
          discountPercent = Math.round((compareAtForBadge - priceCents) / compareAtForBadge * 100);
        }
      }
      priceBadge.classList.toggle('main-product__price-badge--subscription', !!isSubscription);
      if (discountPercent > 0) {
        priceBadge.textContent = '-' + discountPercent + '%';
        priceBadge.style.display = '';
        priceBadge.removeAttribute('aria-hidden');
      } else {
        priceBadge.style.display = 'none';
        priceBadge.setAttribute('aria-hidden', 'true');
      }
    }
  }

  function initProductBuy() {
    document.querySelectorAll('[data-product-buy]').forEach(function (buyBlock) {
      var form = buyBlock.closest('form');
      if (!form) return;

      var qtyInput = buyBlock.querySelector('[data-quantity-input]');
      var minusBtn = buyBlock.querySelector('[data-action="quantity-minus"]');
      var plusBtn = buyBlock.querySelector('[data-action="quantity-plus"]');

      if (qtyInput && minusBtn) {
        minusBtn.addEventListener('click', function () {
          var n = parseInt(qtyInput.value, 10) || 1;
          n = Math.max(1, n - 1);
          qtyInput.value = n;
          updateProductPriceDisplay(form);
        });
      }
      if (qtyInput && plusBtn) {
        plusBtn.addEventListener('click', function () {
          var n = parseInt(qtyInput.value, 10) || 1;
          n = Math.min(99, n + 1);
          qtyInput.value = n;
          updateProductPriceDisplay(form);
        });
      }
      if (qtyInput) {
        qtyInput.addEventListener('change', function () { updateProductPriceDisplay(form); });
        qtyInput.addEventListener('input', function () { updateProductPriceDisplay(form); });
      }

      updateProductPriceDisplay(form);

      var variantIdInput = form.querySelector('input[name="id"]') || form.querySelector('[data-variant-id-input]');
      if (variantIdInput) {
        variantIdInput.addEventListener('change', function () { updateProductPriceDisplay(form); });
        variantIdInput.addEventListener('input', function () { updateProductPriceDisplay(form); });
      }

      var widget = form.querySelector('[data-selling-plan-widget]');
      if (widget) {
        widget.querySelectorAll('.selling-plan-widget__input').forEach(function (radio) {
          radio.addEventListener('change', function () { updateProductPriceDisplay(form); });
        });
      }
    });
  }

  function formatElementPriceToSup(el) {
    // Si ya tiene innerHTML con sup, no procesar de nuevo
    if (el.querySelector('sup')) return;
    
    var text = (el.textContent || '').trim();
    if (!text) return;
    
    // Normalizar formato: asegurar espacio después del $
    var withSpace = text.replace(/^\$(\d)/, '$ $1');
    
    // Buscar patrón: número(s) seguido de punto/coma y dos dígitos
    var parts = withSpace.match(/^(\$?\s*\d+(?:\s*\d{3})*(?:\s*,\d{3})*)([.,]\d{2})(\s*.*)?$/);
    if (parts) {
      el.innerHTML = parts[1] + '<sup class="price-dec">' + parts[2] + '</sup>' + (parts[3] || '');
    } else {
      // Si no tiene decimales, intentar agregar .00
      var noDecimals = withSpace.match(/^(\$?\s*\d+(?:\s*\d{3})*(?:\s*,\d{3})*)(\s*.*)?$/);
      if (noDecimals) {
        el.innerHTML = noDecimals[1] + '<sup class="price-dec">.00</sup>' + (noDecimals[2] || '');
      } else {
        el.textContent = withSpace;
      }
    }
  }

  function formatAllPricesWithSup(container) {
    var root = container || document;
    var selectors = '.product-card__price--current, .product-card__price--compare, .variant-picker__box-price, .selling-plan-widget__option-price:not([data-subscription-price]), .cart-drawer__item-price, [data-cart-drawer-subtotal], .cart-drawer__savings span, [data-main-cart-subtotal], .js-format-price-sup';
    root.querySelectorAll(selectors).forEach(formatElementPriceToSup);
  }

  function formatProductCardPrices() {
    formatAllPricesWithSup();
  }

  function formatSubscriptionPrices() {
    document.querySelectorAll('[data-subscription-price]').forEach(function (el) {
      var text = (el.textContent || '').trim();
      if (!text) return;
      var withSpace = text.replace(/^\$(\d)/, '$ $1');
      var parts = withSpace.match(/^(.*)([.,]\d{2})(\s*.*)?$/);
      if (parts) {
        el.innerHTML = parts[1] + '<sup class="selling-plan-widget__price-dec">' + parts[2] + '</sup>' + (parts[3] || '');
      } else {
        el.textContent = withSpace;
      }
    });
  }

  function initMainCartCheckout() {
    var btn = document.querySelector('[data-main-cart-checkout]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;
      var href = btn.getAttribute('href');
      if (!href) return;
      btn.classList.add('is-loading');
      setTimeout(function () {
        window.location.href = href;
      }, 500);
    });
  }

  function initMegamenu() {
    var panel = document.querySelector('.header-megamenu[data-megamenu-panel]');
    var trigger = document.querySelector('[data-megamenu-trigger]');
    if (!panel || !trigger) return;
    var closeTimer = null;
    function open() {
      clearTimeout(closeTimer);
      closeTimer = null;
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
    }
    function close() {
      closeTimer = setTimeout(function () {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      }, 150);
    }
    function closeNow() {
      clearTimeout(closeTimer);
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    }
    trigger.addEventListener('mouseenter', function () {
      if (window.innerWidth <= 1160) return;
      open();
    });
    trigger.addEventListener('mouseleave', function (e) {
      var to = e.relatedTarget;
      if (to && panel.contains(to)) return;
      close();
    });
    panel.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
    });
    panel.addEventListener('mouseleave', function (e) {
      var to = e.relatedTarget;
      if (to && trigger.contains(to)) return;
      close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNow();
    });
  }

  function init() {
    initHeroSlider();
    initTopBar();
    initTopBarCountdown();
    initHeaderSearch();
    initMegamenu();
    initMobileMenu();
    initCategoryCards();
    initProductGallery();
    initVariantPicker();
    initSellingPlanWidget();
    initProductBuy();
    initMainCartCheckout();
    formatAllPricesWithSup();
    formatSubscriptionPrices();
  }

  window.formatAllPricesWithSup = formatAllPricesWithSup;

  function formatCentsToMoney(cents) {
    if (cents == null || isNaN(cents)) return '$ 0.00';
    try {
      var amount = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return '$ ' + amount;
    } catch (e) {
      return '$ ' + (cents / 100).toFixed(2);
    }
  }

  function initFrequentlyBought() {
    document.querySelectorAll('[data-frequently-bought]').forEach(function (block) {
      var checkboxes = block.querySelectorAll('[data-fb-checkbox]');
      var totalEl = block.querySelector('[data-fb-total]');
      var savingsBadge = block.querySelector('[data-fb-savings-badge]');
      var savingsAmountEl = block.querySelector('[data-fb-savings-amount]');
      var savingsLine = block.querySelector('[data-fb-savings-line]');
      var btn = block.querySelector('[data-frequently-bought-add]');
      var btnText = btn ? btn.querySelector('.frequently-bought__btn-text') : null;
      var btnLoader = btn ? btn.querySelector('.frequently-bought__btn-loader') : null;

      function getMainVariantPrices() {
        var form = document.querySelector('[data-product-form]');
        if (!form) return { price: 0, compare_at: 0 };
        var variantInput = form.querySelector('input[name="id"]') || form.querySelector('[data-variant-id-input]');
        var variantId = variantInput ? (variantInput.value || '').trim() : '';
        if (!variantId) return { price: 0, compare_at: 0 };
        var script = form.querySelector('[data-product-prices]');
        if (!script) return { price: 0, compare_at: 0 };
        try {
          var data = JSON.parse(script.textContent);
          var v = data.variants && data.variants[variantId];
          if (!v) return { price: 0, compare_at: 0 };
          return {
            price: parseInt(v.price_cents, 10) || 0,
            compare_at: parseInt(v.compare_at_cents, 10) || 0
          };
        } catch (e) {
          return { price: 0, compare_at: 0 };
        }
      }

      function updateTotal() {
        var additionalSum = 0;
        var additionalCompareSum = 0;
        checkboxes.forEach(function (cb) {
          if (cb.checked) {
            additionalSum += parseInt(cb.getAttribute('data-price-cents'), 10) || 0;
            additionalCompareSum += parseInt(cb.getAttribute('data-compare-at-cents'), 10) || 0;
          }
        });
        if (totalEl) totalEl.innerHTML = formatPriceWithSup(formatCentsToMoney(additionalSum));

        var main = getMainVariantPrices();
        var totalSale = main.price + additionalSum;
        var totalCompare = (main.compare_at > 0 ? main.compare_at : main.price) + (additionalCompareSum > 0 ? additionalCompareSum : additionalSum);
        var savingsCents = totalCompare > totalSale ? totalCompare - totalSale : 0;
        var savingsPct = totalCompare > 0 && savingsCents > 0 ? Math.round((savingsCents / totalCompare) * 100) : 0;

        if (savingsBadge) {
          savingsBadge.textContent = savingsPct > 0 ? '-' + savingsPct + '%' : '';
          savingsBadge.setAttribute('aria-hidden', savingsPct > 0 ? 'false' : 'true');
        }
        if (savingsAmountEl) {
          savingsAmountEl.innerHTML = savingsCents > 0 ? formatPriceWithSup(formatCentsToMoney(savingsCents)) : '';
        }
        if (savingsLine) {
          savingsLine.classList.toggle('frequently-bought__savings-line--has-amount', savingsCents > 0);
        }
      }

      checkboxes.forEach(function (cb) {
        cb.addEventListener('change', updateTotal);
      });
      var form = document.querySelector('[data-product-form]');
      if (form) {
        var variantInput = form.querySelector('input[name="id"]') || form.querySelector('[data-variant-id-input]');
        if (variantInput) {
          variantInput.addEventListener('change', updateTotal);
          variantInput.addEventListener('input', updateTotal);
        }
      }
      updateTotal();

      if (btn) {
        btn.addEventListener('click', function () {
          var form = document.querySelector('[data-product-form]');
          var mainVariantInput = form ? form.querySelector('input[name="id"]') || form.querySelector('[data-variant-id-input]') : null;
          var mainVariantId = mainVariantInput ? (mainVariantInput.value || '').trim() : '';
          var selectedIds = [];
          checkboxes.forEach(function (cb) {
            if (cb.checked) selectedIds.push((cb.getAttribute('data-variant-id') || cb.value || '').trim());
          });
          var idsToAdd = [];
          if (mainVariantId) idsToAdd.push(mainVariantId);
          selectedIds.forEach(function (id) { if (id) idsToAdd.push(id); });
          if (idsToAdd.length === 0) {
            if (typeof window.showCartError === 'function') window.showCartError('Selecciona al menos un producto');
            else alert('Selecciona al menos un producto');
            return;
          }
          btn.disabled = true;
          btn.classList.add('is-loading');
          var Cart = window.CartAjax;
          if (!Cart || typeof Cart.addToCart !== 'function') {
            btn.disabled = false;
            btn.classList.remove('is-loading');
            return;
          }
          var promise = Cart.addToCart({ id: idsToAdd[0], quantity: 1 });
          for (var i = 1; i < idsToAdd.length; i++) {
            (function (vid) {
              promise = promise.then(function () {
                return Cart.addToCart({ id: vid, quantity: 1 });
              });
            })(idsToAdd[i]);
          }
          promise
            .then(function (res) {
              if (res && res.ok) {
                var drawerSectionId = null;
                var headerSectionId = null;
                var drawer = document.querySelector('[data-cart-drawer]');
                if (drawer) {
                  var section = drawer.closest('[id^="shopify-section-"]');
                  if (section) drawerSectionId = section.id.replace('shopify-section-', '');
                }
                var countEl = document.querySelector('[data-cart-count]');
                if (countEl && countEl.closest('[id^="shopify-section-"]')) {
                  headerSectionId = countEl.closest('[id^="shopify-section-"]').id.replace('shopify-section-', '');
                }
                var sectionIds = [drawerSectionId, headerSectionId].filter(Boolean);
                if (sectionIds.length && typeof Cart.renderSections === 'function') {
                  return Cart.renderSections(sectionIds).then(function () {
                    if (typeof Cart.openDrawer === 'function') Cart.openDrawer(true);
                  });
                }
                if (typeof Cart.openDrawer === 'function') Cart.openDrawer();
              } else {
                var msg = (res && res.data && (res.data.description || res.data.message)) || 'No se pudo agregar';
                if (typeof window.showCartError === 'function') window.showCartError(msg);
                else alert(msg);
              }
            })
            .catch(function () {
              if (typeof window.showCartError === 'function') window.showCartError('Error de conexión');
              else alert('Error de conexión');
            })
            .finally(function () {
              btn.disabled = false;
              btn.classList.remove('is-loading');
            });
        });
      }
    });
  }

  function initProductSlider() {
    var sliders = document.querySelectorAll('[data-product-slider]');
    if (!sliders.length) return;
    
    sliders.forEach(function(slider) {
      var cards = slider.querySelectorAll('.product-card');
      if (!cards.length) return;
      
      var isScrolling = false;
      var isDesktop = window.innerWidth > 749;
      var itemsPerView = isDesktop ? 5 : 2;
      var startX = 0;
      var scrollLeft = 0;
      var autoplayTimer = null;
      var autoplayEnabled = slider.dataset.autoplay === 'true';
      var autoplayInterval = parseInt(slider.dataset.autoplayInterval, 10) || 5000;
      var section = slider.closest('.product-loop');
      
      if (cards.length <= itemsPerView) return; // No necesita slider si hay menos productos que los visibles
      
      function scrollToPosition(position, smooth) {
        isScrolling = true;
        slider.scrollTo({ left: position, behavior: smooth ? 'smooth' : 'auto' });
        setTimeout(function() { isScrolling = false; }, 300);
      }
      
      function getCardWidth() {
        return cards[0].offsetWidth + (isDesktop ? 24 : 16);
      }
      
      function scrollNext() {
        var cardWidth = getCardWidth();
        var currentScroll = slider.scrollLeft;
        var scrollAmount = cardWidth * itemsPerView;
        var maxScroll = slider.scrollWidth - slider.clientWidth;
        var nextPosition = Math.min(currentScroll + scrollAmount, maxScroll);
        scrollToPosition(nextPosition, true);
      }
      
      function scrollPrev() {
        var cardWidth = getCardWidth();
        var currentScroll = slider.scrollLeft;
        var scrollAmount = cardWidth * itemsPerView;
        var prevPosition = Math.max(currentScroll - scrollAmount, 0);
        scrollToPosition(prevPosition, true);
      }
      
      function startAutoplay() {
        if (!autoplayEnabled) return;
        stopAutoplay();
        autoplayTimer = setInterval(function() {
          var maxScroll = slider.scrollWidth - slider.clientWidth;
          if (slider.scrollLeft >= maxScroll - 10) {
            // Volver al inicio
            scrollToPosition(0, true);
          } else {
            scrollNext();
          }
        }, autoplayInterval);
      }
      
      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }
      
      // Botones de navegación
      if (section) {
        var prevBtn = section.querySelector('[data-product-slider-prev]');
        var nextBtn = section.querySelector('[data-product-slider-next]');
        
        if (prevBtn) {
          prevBtn.addEventListener('click', function() {
            stopAutoplay();
            scrollPrev();
            if (autoplayEnabled) setTimeout(startAutoplay, autoplayInterval);
          });
        }
        
        if (nextBtn) {
          nextBtn.addEventListener('click', function() {
            stopAutoplay();
            scrollNext();
            if (autoplayEnabled) setTimeout(startAutoplay, autoplayInterval);
          });
        }
      }
      
      var snapTimeout = null;
      var isUserScrolling = false;
      
      // Snap scroll (solo después de que el usuario termine de hacer scroll)
      slider.addEventListener('scroll', function() {
        if (isScrolling) return;
        isUserScrolling = true;
        
        // Limpiar timeout anterior
        if (snapTimeout) clearTimeout(snapTimeout);
        
        // Aplicar snap solo después de que el usuario termine de hacer scroll
        snapTimeout = setTimeout(function() {
          if (!isScrolling && isUserScrolling) {
            var cardWidth = getCardWidth();
            var scrollPosition = slider.scrollLeft;
            var snapPosition = Math.round(scrollPosition / (cardWidth * itemsPerView)) * (cardWidth * itemsPerView);
            if (Math.abs(scrollPosition - snapPosition) > 5) {
              slider.scrollTo({ left: snapPosition, behavior: 'smooth' });
            }
            isUserScrolling = false;
          }
        }, 150);
      });
      
      // Pausar autoplay al interactuar
      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', function() {
        if (autoplayEnabled) startAutoplay();
      });
      
      // Touch events para móvil
      if (!isDesktop) {
        slider.addEventListener('touchstart', function(e) {
          stopAutoplay();
          isScrolling = true;
          startX = e.touches[0].pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
        }, { passive: true });
        
        slider.addEventListener('touchend', function() {
          setTimeout(function() { 
            isScrolling = false;
            if (autoplayEnabled) startAutoplay();
          }, 100);
        }, { passive: true });
      }
      
      // Mouse wheel para desktop (solo scroll horizontal, permitir scroll vertical normal)
      if (isDesktop) {
        slider.addEventListener('wheel', function(e) {
          // Solo interceptar scroll horizontal (deltaX)
          // Permitir scroll vertical (deltaY) para que funcione normalmente
          if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
            stopAutoplay();
            e.preventDefault();
            slider.scrollLeft += e.deltaX;
            isUserScrolling = true;
            if (autoplayEnabled) setTimeout(startAutoplay, autoplayInterval);
          }
          // Si es scroll vertical (deltaY), no hacer nada y dejar que funcione normalmente
        }, { passive: false });
      }
      
      // Iniciar autoplay si está habilitado
      if (autoplayEnabled) {
        startAutoplay();
      }
      
      // Formatear precios después de inicializar el slider
      if (typeof window.formatAllPricesWithSup === 'function') {
        window.formatAllPricesWithSup(slider);
      }
    });
  }

  function initManualVariantsSlider() {
    var gap = 12;
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-manual-variants-prev], [data-manual-variants-next]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var container = btn.closest('.manual-variants__slider');
      if (!container) return;
      var list = container.querySelector('[data-manual-variants-slider]');
      if (!list || list.scrollWidth <= list.clientWidth) return;
      var items = list.querySelectorAll('.manual-variants__item');
      if (!items.length) return;
      var step = (items[0] ? items[0].offsetWidth : 98) + gap;
      var direction = btn.matches('[data-manual-variants-next]') ? 1 : -1;
      var newScroll = Math.max(0, Math.min(list.scrollLeft + direction * step, list.scrollWidth - list.clientWidth));
      list.scrollTo({ left: newScroll, behavior: 'smooth' });
    });
    function updateNavVisibility() {
      document.querySelectorAll('.manual-variants__slider').forEach(function(container) {
        var list = container.querySelector('[data-manual-variants-slider]');
        if (!list) return;
        var items = list.querySelectorAll('.manual-variants__item');
        var prevBtn = container.querySelector('[data-manual-variants-prev]');
        var nextBtn = container.querySelector('[data-manual-variants-next]');
        var showArrows = items.length > 4;
        if (prevBtn) prevBtn.style.display = showArrows ? '' : 'none';
        if (nextBtn) nextBtn.style.display = showArrows ? '' : 'none';
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateNavVisibility);
    } else {
      updateNavVisibility();
    }
    window.addEventListener('resize', updateNavVisibility);
  }

  function initPanelBadges() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-panel-badge]');
      if (!link || !link.href) return;
      var id = link.getAttribute('href');
      if (!id || id.charAt(0) !== '#') return;
      var panel = document.querySelector(id);
      if (!panel || !panel.classList.contains('product-panels__panel')) return;
      e.preventDefault();
      var container = panel.closest('[data-product-panels]');
      if (container) {
        if (typeof window.switchProductPanelTab === 'function') window.switchProductPanelTab(panel);
        container.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  function initProductPanelsTabs() {
    /* Tabs use radio+label (no JS) */
  }

  function initCategorySlider() {
    var sliders = document.querySelectorAll('[data-category-slider]');
    if (!sliders.length) return;
    
    sliders.forEach(function(slider) {
      var cards = slider.querySelectorAll('.collection-category-card');
      if (!cards.length) return;
      
      var isScrolling = false;
      var isDesktop = window.innerWidth > 749;
      var itemsPerView = isDesktop ? 3 : 2;
      var startX = 0;
      var scrollLeft = 0;
      var container = slider.closest('.collection-category-slider');
      
      if (cards.length <= itemsPerView) {
        // Ocultar botones si no hay suficientes categorías
        if (container) {
          var prevBtn = container.querySelector('[data-category-slider-prev]');
          var nextBtn = container.querySelector('[data-category-slider-next]');
          if (prevBtn) prevBtn.style.display = 'none';
          if (nextBtn) nextBtn.style.display = 'none';
        }
        return;
      }
      
      function updateNavButtons() {
        if (!container) return;
        var prevBtn = container.querySelector('[data-category-slider-prev]');
        var nextBtn = container.querySelector('[data-category-slider-next]');
        var maxScroll = slider.scrollWidth - slider.clientWidth;
        
        if (prevBtn) {
          prevBtn.disabled = slider.scrollLeft <= 0;
        }
        if (nextBtn) {
          nextBtn.disabled = slider.scrollLeft >= maxScroll - 10;
        }
      }
      
      function scrollToPosition(position, smooth) {
        isScrolling = true;
        slider.scrollTo({ left: position, behavior: smooth ? 'smooth' : 'auto' });
        setTimeout(function() { 
          isScrolling = false;
          updateNavButtons();
        }, 300);
      }
      
      function getCardWidth() {
        return cards[0].offsetWidth + (isDesktop ? 24 : 16);
      }
      
      function scrollNext() {
        var cardWidth = getCardWidth();
        var currentScroll = slider.scrollLeft;
        var scrollAmount = cardWidth * itemsPerView;
        var maxScroll = slider.scrollWidth - slider.clientWidth;
        var nextPosition = Math.min(currentScroll + scrollAmount, maxScroll);
        scrollToPosition(nextPosition, true);
      }
      
      function scrollPrev() {
        var cardWidth = getCardWidth();
        var currentScroll = slider.scrollLeft;
        var scrollAmount = cardWidth * itemsPerView;
        var prevPosition = Math.max(currentScroll - scrollAmount, 0);
        scrollToPosition(prevPosition, true);
      }
      
      // Botones de navegación
      if (container) {
        var prevBtn = container.querySelector('[data-category-slider-prev]');
        var nextBtn = container.querySelector('[data-category-slider-next]');
        
        if (prevBtn) {
          prevBtn.addEventListener('click', function() {
            scrollPrev();
          });
        }
        
        if (nextBtn) {
          nextBtn.addEventListener('click', function() {
            scrollNext();
          });
        }
      }
      
      // Actualizar botones al hacer scroll
      slider.addEventListener('scroll', function() {
        if (!isScrolling) {
          updateNavButtons();
        }
      });
      
      // Touch events para móvil
      if (!isDesktop) {
        slider.addEventListener('touchstart', function(e) {
          isScrolling = true;
          startX = e.touches[0].pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
        }, { passive: true });
        
        slider.addEventListener('touchend', function() {
          setTimeout(function() { 
            isScrolling = false;
            updateNavButtons();
          }, 100);
        }, { passive: true });
      }
      
      // Mouse wheel para desktop
      if (isDesktop) {
        slider.addEventListener('wheel', function(e) {
          e.preventDefault();
          slider.scrollLeft += e.deltaY;
          updateNavButtons();
        }, { passive: false });
      }
      
      // Actualizar botones inicialmente
      updateNavButtons();
      
      // Formatear precios después de inicializar
      if (typeof window.formatAllPricesWithSup === 'function') {
        window.formatAllPricesWithSup(container);
      }
      
      // Actualizar en resize
      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          isDesktop = window.innerWidth > 749;
          itemsPerView = isDesktop ? 3 : 2;
          updateNavButtons();
          if (typeof window.formatAllPricesWithSup === 'function') {
            window.formatAllPricesWithSup(container);
          }
        }, 250);
      });
    });
  }

  function initStarRatings() {
    // El plugin LAI Product Reviews se inicializa automáticamente cuando detecta elementos con clase scm-reviews-rate
    var ratingElements = document.querySelectorAll('.scm-reviews-rate');
    
    ratingElements.forEach(function(el) {
      // Asegurar que el elemento sea visible
      if (el.style.display === 'none') {
        el.style.display = '';
      }
      if (el.style.visibility === 'hidden') {
        el.style.visibility = 'visible';
      }
      el.style.opacity = '1';
      
      // Verificar que tenga el data-product-id
      if (!el.getAttribute('data-product-id')) {
        var productIdEl = el.closest('[data-product-id]');
        if (productIdEl) {
          var productId = productIdEl.getAttribute('data-product-id');
          if (productId) {
            el.setAttribute('data-product-id', productId);
          }
        }
      }
      
      // Verificar que el data-rate-version2 tenga un valor válido
      var rateData = el.getAttribute('data-rate-version2');
      // Si el valor es "null" como string, mantenerlo ya que el plugin puede necesitarlo
      // Solo remover si está completamente vacío o es undefined
      if (rateData === 'undefined' || rateData === '') {
        el.setAttribute('data-rate-version2', 'null');
      }
      
      // Forzar re-renderizado removiendo y agregando la clase
      el.classList.remove('scm-reviews-rate');
      setTimeout(function() {
        el.classList.add('scm-reviews-rate');
      }, 10);
    });
    
    // Si el plugin tiene métodos de inicialización globales, intentar usarlos
    if (typeof window.scmReviewRateInit === 'function') {
      ratingElements.forEach(function(el) {
        try {
          window.scmReviewRateInit(el);
        } catch (e) {
          console.warn('Error initializing star rating:', e);
        }
      });
    }
    
    // Intentar con otros posibles métodos
    if (typeof window.SCMReviewRate !== 'undefined' && window.SCMReviewRate.init) {
      ratingElements.forEach(function(el) {
        try {
          window.SCMReviewRate.init(el);
        } catch (e) {
          console.warn('Error initializing star rating:', e);
        }
      });
    }
    
    // Intentar disparar eventos para que el plugin detecte los elementos
    ratingElements.forEach(function(el) {
      try {
        var event = new CustomEvent('scm-rating-init', { bubbles: true, detail: { element: el } });
        el.dispatchEvent(event);
      } catch (e) {
        // Ignorar si CustomEvent no está disponible
      }
    });
  }
  
  // Usar MutationObserver para detectar cuando se agregan nuevas cards dinámicamente
  function setupStarRatingObserver() {
    var observer = new MutationObserver(function(mutations) {
      var shouldInit = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              if (node.classList && node.classList.contains('scm-reviews-rate')) {
                shouldInit = true;
              } else if (node.querySelector && node.querySelector('.scm-reviews-rate')) {
                shouldInit = true;
              }
            }
          });
        }
      });
      if (shouldInit) {
        setTimeout(initStarRatings, 100);
      }
    });
    
    // Observar cambios en el documento
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      initFrequentlyBought();
      initProductSlider();
      initManualVariantsSlider();
      initPanelBadges();
      initProductPanelsTabs();
      initCategorySlider();
      // Formatear precios después de inicializar todo
      setTimeout(function() {
        if (typeof window.formatAllPricesWithSup === 'function') {
          window.formatAllPricesWithSup();
        }
      }, 100);
      // Configurar observer para star ratings
      setupStarRatingObserver();
      // Inicializar star ratings después de múltiples delays para asegurar que el plugin esté cargado
      setTimeout(initStarRatings, 500);
      setTimeout(initStarRatings, 1500);
      setTimeout(initStarRatings, 3000);
    });
  } else {
    init();
    initFrequentlyBought();
    initProductSlider();
    initManualVariantsSlider();
    initPanelBadges();
    initCategorySlider();
    // Formatear precios después de inicializar todo
    setTimeout(function() {
      if (typeof window.formatAllPricesWithSup === 'function') {
        window.formatAllPricesWithSup();
      }
    }, 100);
    setupStarRatingObserver();
    setTimeout(initStarRatings, 500);
    setTimeout(initStarRatings, 1500);
    setTimeout(initStarRatings, 3000);
  }

  // Re-inicializar después de cambios dinámicos (por ejemplo, después de AJAX)
  window.initStarRatings = initStarRatings;
  
  // También intentar inicializar cuando el plugin esté listo (si tiene eventos)
  if (typeof window.addEventListener !== 'undefined') {
    window.addEventListener('load', function() {
      setTimeout(initStarRatings, 1000);
    });
  }
})();

/* ==========================================================================
   Header compacto al hacer scroll
   Añade la clase .header-scrolled a <html> pasado el umbral, para ocultar el
   buscador (escritorio y móvil). Se revierte al volver arriba.
   ========================================================================== */
(function () {
  var THRESHOLD = 60;

  // La clase va en <html>, no en el header: el carrito re-renderiza la sección
  // del header (cart.js → refreshCartUI) reemplazando su innerHTML, lo que
  // destruiría el elemento y perdería el estado en cada apertura del carrito.
  var root = document.documentElement;
  var ticking = false;

  function isEnabled() {
    return !!document.querySelector('[data-header-compact-on-scroll]');
  }

  function update() {
    ticking = false;
    var shouldCompact = isEnabled() && window.scrollY > THRESHOLD;
    root.classList.toggle('header-scrolled', shouldCompact);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  update();
})();
